export const SET_FOOTER_LINKS = "SET_FOOTER_LINKS";

export const setFooterLinks = (footerLinks) => {
  return {
    type: SET_FOOTER_LINKS,
    payload: footerLinks,
  };
};

